export const PxToVw = (px: number, baseWidth: number) =>
  `${px * (100 / baseWidth)}vw`

export const PxToVh = (px: number, baseHeight: number) =>
  `${px * (100 / baseHeight)}vh`
